import diagram from "../../../../contents/images/docs/cloud/cloudfront-proxy/cache-policy.png";
import * as React from 'react';
export default {
  diagram,
  React
};